import { Icon } from '@iconify/react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  IconButton,
  InputAdornment,
  Paper,
  Rating,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { lightBlue } from '@mui/material/colors';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useEffect, useMemo, useRef, useState } from 'react';
import { createReview } from 'src/api/public/readerReviewBook';
import { useGetBookPublicBySlug } from 'src/api/public/searchBook';
import EmptyContent from 'src/components/empty-content';
import Iconify from 'src/components/iconify';
import Image from 'src/components/image';
import Label from 'src/components/label/label';
import Scrollbar from 'src/components/scrollbar';
import { IMAGE_HOST_API } from 'src/config-global';
import { useParams, useRouter } from 'src/routes/hooks';
// import GuestToolbox from '../_components/guest-toolbox';
import { enqueueSnackbar } from 'notistack';
import { useAuthContext } from 'src/auth/hooks';
import { fToNow } from 'src/utils/format-time';
import {
  ButtonAddToBasket,
  ButtonBorrowRegister,
  ButtonRemoveFromBasket,
} from '../_components/public-buttons';
import RegisterBorrowBookForm from '../_components/register-borrow-book-form/register-borrow-book-form';
import useBasket from '../_hooks/useBasket';

export default function ChiTietAnPham() {
  const { user } = useAuthContext();
  const { bookInStorage, removeFromBasket, toBasket } = useBasket();
  const { back } = useRouter();
  const { slug } = useParams();
  const [bookBorrow, setBookBorrow] = useState<any>(null);
  const [reviewText, setReviewText] = useState('');
  const [rating, setRating] = useState(0);
  const [comments, setComments] = useState<
    {
      id: number;
      author: string;
      text: string;
      rated: number;
      timestamp: string;
    }[]
  >([]);
  const lastCommentRef = useRef<HTMLDivElement | null>(null);

  const {
    data: { data: book },
    isLoading,
  } = useGetBookPublicBySlug(slug as any);

  const totalAvailabel = useMemo(() => {
    return (
      book?.manageInfor?.reduce((acc, b) => {
        if (b.isReady) return acc + 1;
        return acc;
      }, 0) || 0
    );
  }, [book]);

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      field: 'code',
      headerName: 'Mã ấn phẩm',
      flex: 1,
    },
    {
      field: 'position',
      headerName: 'Vị trí lưu trữ',
      flex: 1,
    },
    {
      field: 'isReady',
      headerName: 'Trạng thái ấn phẩm',
      flex: 1,
      align: 'center',
      headerAlign: 'center',

      renderCell: (params) => (
        <Label color={params.row.isReady ? 'success' : 'error'}>
          {params.row.isReady ? 'Sẵn sàng' : 'Không có sẵn'}
        </Label>
      ),
    },
    // {
    //   field: 'actions',
    //   headerName: 'Hành động',
    //   flex: 1,
    //   align: 'center',
    //   headerAlign: 'center',

    //   renderCell: (params) => (
    //     <Stack sx={{ maxWidth: 150 }} my={0.5}>
    //       {params.row.isReady && (
    //         <ButtonBorrowRegister
    //           onClick={() => setBookBorrow({ ids: [params.id], infors: [book] })}
    //         />
    //       )}
    //       {!bookInStorage.includes(params.id) && (
    //         <ButtonAddToBasket onClick={() => toBasket(params.id)} />
    //       )}
    //       {bookInStorage.includes(params.id) && (
    //         <ButtonRemoveFromBasket onClick={() => removeFromBasket(params.id)} />
    //       )}
    //     </Stack>
    //   ),
    // },
  ];

  const rows = book?.manageInfor?.map((infor) => ({
    id: infor.bookId,
    code: infor.bookCode,
    position: infor.positionName,
    isReady: infor.isReady,
    actions: infor.bookId,
  }));

  useEffect(() => {
    if (book?.reviewsList?.length) {
      setComments(
        book.reviewsList.map((review) => ({
          id: review.id,
          author: review.userName,
          text: review.content,
          rated: review.rating,
          timestamp: fToNow(review.createdAt),
        }))
      );
    }
  }, [book?.reviewsList]);

  useEffect(() => {
    if (lastCommentRef.current) {
      lastCommentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [comments]);

  const handleSubmitReview = async () => {
    if (!reviewText.trim()) {
      return;
    }

    if (rating === 0) {
      enqueueSnackbar('Vui lòng đánh giá ít nhất 1 sao!', { variant: 'warning' });
      return;
    }

    const formData = { content: reviewText, rating };

    try {
      const sendReq = await createReview(formData, book.id);
      setComments([
        ...comments,
        {
          id: sendReq.id,
          author: user?.fullName,
          text: reviewText,
          rated: rating,
          timestamp: fToNow(new Date()),
        },
      ]);

      if (sendReq?.message) {
        enqueueSnackbar(sendReq.message, { variant: 'success' });
      } else {
        enqueueSnackbar(sendReq.message, { variant: 'error' });
      }

      setReviewText('');
      setRating(0);
    } catch (error) {
      console.log('Error submitting review:', error);
      enqueueSnackbar('Lỗi khi gửi đánh giá!', { variant: 'error' });
    }
  };

  return (
    <>
      {/* <GuestToolbox /> */}
      {!isLoading && !!book && (
        <Stack sx={{ maxWidth: 1080, width: '90%', mx: 'auto' }} spacing={0.5}>
          <Button
            fullWidth
            variant="outlined"
            sx={{ maxWidth: 200, mx: 'auto', my: 1, mt: 3 }}
            onClick={back}
          >
            Quay lại
          </Button>
          <Divider />
          <Stack direction="column" alignItems="center" gap={0.5} justifyContent="center">
            <Image
              src={IMAGE_HOST_API + book.photoURL}
              alt={book.name}
              ratio="4/6"
              sx={{
                maxWidth: {
                  xs: 200,
                  md: 250,
                  lg: 300,
                },
                padding: 0.5,
                border: '1px solid #f2f2f2',
                borderRadius: 0.5,
              }}
            />
          </Stack>

          <Stack>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="h3" component="h3">
                {book.name}
              </Typography>
              <Iconify icon="fxemoji:openbook" sx={{ transform: 'rotate(10deg)' }} width={25} />
            </Box>
            <Typography variant="subtitle1">{book.author} (Tác giả)</Typography>
            {book.description && <Typography variant="body1">{book.description}</Typography>}

            <Accordion sx={{ mt: 0.5 }}>
              <AccordionSummary>
                <Button variant="outlined">
                  <Iconify icon="heroicons-solid:information-circle" color={lightBlue[200]} />
                  Xem thêm chi tiết
                </Button>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <Typography>
                    <strong>Danh mục sách: </strong>
                    {book.categoryName}
                  </Typography>
                  <Typography>
                    <strong>Nhà xuất bản: </strong> {book.publisherName}
                  </Typography>
                  <Typography>
                    <strong>Ngôn ngữ: </strong> {book.language}
                  </Typography>
                  <Box>
                    <strong>Lĩnh vực: </strong>
                    {book.fieldList.map((field, id) => (
                      <Chip
                        key={`${field}-${id}`}
                        label={field}
                        variant="soft"
                        size="small"
                        sx={{ mr: 0.5 }}
                      />
                    ))}
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Stack>
          <Box mt={1}>
            {book.manageInfor.length === 0 && (
              <EmptyContent title="Ấn phẩm này chưa có vị trí lưu trữ !" />
            )}
            {book.manageInfor.length > 0 && (
              <>
                <Typography variant="h6">Ấn phẩm sẵn có</Typography>
                <Typography variant="body2" pl={0.5}>
                  • Hiện có <strong>{totalAvailabel}</strong>/{book.manageInfor.length} ấn phẩm tại
                  thư viện
                </Typography>
                <Scrollbar>
                  <Box minWidth={450}>
                    <DataGrid
                      rows={rows}
                      columns={columns}
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 5,
                          },
                        },
                      }}
                      sx={{
                        '& .MuiDataGrid-cell': {
                          paddingTop: '8px',
                          paddingBottom: '8px',
                        },
                      }}
                      pageSizeOptions={[5, 10, 20]}
                      disableRowSelectionOnClick
                      disableColumnMenu
                      density="standard"
                      getRowHeight={() => 'auto'}
                    />
                  </Box>
                </Scrollbar>
              </>
            )}
          </Box>
          {/* Comments Section */}
          <Paper
            sx={{
              marginTop: 5,
              p: 2,
              width: '100%',
              border: '1px solid #ddd',
              borderTop: 'unset',
              borderBottom: 'unset',
              borderEndEndRadius: 'unset',
              borderEndStartRadius: 'unset',
              boxShadow: '0px -4px 10px -4px rgba(0,0,0,0.15)',
            }}
          >
            <Typography variant="h6" sx={{ display: "inline" }}>Bình luận</Typography>
            <Typography variant="h6" sx={{ fontWeight: "unset", display: "inline" }}> ({comments?.length ? comments.length : 0})</Typography>

            <Box
              sx={{
                maxHeight: 300,
                overflowY: 'auto',
                mb: 2,
                mt: 3,
                pr: 1,
              }}
            >
              {comments.length > 0 ? (
                comments.map((comment, index) => (
                  <Box
                    key={index}
                    ref={index === comments.length - 1 ? lastCommentRef : null}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mb: 4,
                      p: 1,
                      bgcolor: '#f9f9f9',
                      borderRadius: 2,
                    }}
                  >
                    <Icon
                      icon="mdi:account-circle"
                      width={30}
                      height={30}
                      style={{ marginRight: 8, marginLeft: 8 }}
                    />
                    <Box sx={{ flexGrow: 1 }}>
                      {/* Name & Time Sent */}
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ py: 1 }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                            {comment.author}
                          </Typography>
                          <Rating value={comment.rated} readOnly size="small" />
                        </Box>
                        <Typography
                          variant="caption"
                          textTransform="capitalize"
                          color="text.secondary"
                          sx={{ mx: 2 }}
                        >
                          {comment.timestamp}
                        </Typography>
                      </Stack>
                      <Typography variant="body2" color="text.secondary">
                        {comment.text}
                      </Typography>
                    </Box>
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  Chưa có bình luận nào.
                </Typography>
              )}
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
              <Typography variant="body1">Đánh giá về ấn phẩm này:</Typography>
              <Rating
                name="rating"
                value={rating}
                onChange={(event, newValue) => setRating(newValue || 5)}
                precision={1}
              />
            </Box>

            <TextField
              fullWidth
              label="Viết bình luận..."
              variant="outlined"
              sx={{ mt: 2 }}
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      color="primary"
                      onClick={handleSubmitReview}
                      disabled={!reviewText.trim()}
                    >
                      <Icon icon="mdi:arrow-up-circle" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Paper>
          <Button
            fullWidth
            variant="outlined"
            sx={{ maxWidth: 200, mx: 'auto', my: 1, mt: 3 }}
            onClick={back}
          >
            Quay lại
          </Button>
        </Stack>
      )}
      {isLoading && !book && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={4}
          sx={{ position: 'absolute', width: 1 }}
        >
          <CircularProgress size={80} />
        </Box>
      )}
      {!isLoading && !book && (
        <EmptyContent
          title="Oop! Không tìm thấy ấn phẩm này!"
          imgUrl="assets/icons/empty/ic_cart.svg"
        />
      )}
      <RegisterBorrowBookForm
        open={!!bookBorrow}
        books={bookBorrow}
        onClose={() => setBookBorrow(null)}
      />
    </>
  );
}
